import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/user/Login'
import UserList from '@/components/user/UserList'
import User from '@/components/user/User'
import Admin from '@/components/user/Admin'
import Datasets from '@/components/datasets'
import Lists from '@/components/lists'
import Gene from '@/components/geneView'
import GeneList from '@/components/geneList'
import GeneSearch from '@/components/geneSearch'
import DatasetDetails from '@/components/datasetDetails'
import store from '@/store'

import PermissionDenied from '@/components/user/PermissionDenied'
import Register from '@/components/user/Register'
import AccountValidation from '@/components/user/AccountValidation'
import AccountActivation from '@/components/user/AccountActivation'
import forgetPassword from '@/components/user/forgetPassword'
import SetNewPassword from '@/components/user/setNewPassword'

// import {ServerTable, ClientTable, Event} from 'vue-tables-2';

Vue.use(Router);
// Vue.use(ClientTable);

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home,
			beforeEnter: requireAuth,
			meta: {permissions: 'active',condition: 'any'}
		},
		{
			path: '/lists',
			name: 'lists',
			component: Lists,
			beforeEnter: requireAuth,
			meta: {permissions: 'active',condition: 'any'}
		},
		{
			path: '/gene',
			name: 'gene',
			component: GeneSearch,
			beforeEnter: requireAuth,
			meta: {permissions: 'active',condition: 'any'}
		},
		{
			path: '/gene/:ensemblID',
			name: 'gene',
			component: Gene,
			beforeEnter: requireAuth,
			meta: {permissions: 'active',condition: 'any'}
		},
		{
			path: '/datasets',
			name: 'datasets',
			component: Datasets,
			beforeEnter: requireAuth,
			meta: {permissions: 'active',condition: 'any'}
		},
		{
			path: '/dataset/:dataset_id',
			name: 'datasetDetails',
			component: DatasetDetails,
			beforeEnter: requireAuth,
			meta: {permissions: 'active',condition: 'any'}
		},
		{
			path: '/home',
			name: 'home',
			component: Home,
			beforeEnter: requireAuth,
			meta: {permissions: 'active',condition: 'any'}
		},
		{
			path: '/users',
			name: 'users',
			component: UserList,
			beforeEnter: requireAuth,
			meta: {permissions: 'active',condition: 'any'}
		},
		{
			path: '/admin',
			name: 'admin',
			component: Admin,
			beforeEnter: requireAuth,
			meta: {permissions: 'admin',condition: 'any'}
		},
		{
			path: '/user/:user_id',
			name: 'user',
			component: User,
			beforeEnter: requireAuth,
			meta: {permissions: 'active',condition: 'any'}
		},
		{
			path: '/login',
			name: 'login',
			component: Login
		},
		{
			path: '/permissionDenied',
			name: 'permissionDenied',
			component: PermissionDenied
		},
		{
			path: '/register',
			name: 'register',
			component: Register
		},
		{
			path: '/validationrequired',
			name: 'setCredentials',
			component: AccountValidation
		},
		{
			path: '/setnewpassword',
			name: 'setNewPassword',
			component: SetNewPassword
		},
		{
			path: '/activation/:param',
			name: 'accountActivation',
			component: AccountActivation,
			// beforeEnter: requireAuth,
			meta: {permissions: 'active',condition: 'any'}
		},
		{
			path: '/reject/:param',
			name: 'accountActivation',
			component: AccountActivation,
			// beforeEnter: requireAuth,
			meta: {permissions: 'active',condition: 'any'}
		},
		{
			path: '/forgetPassword',
			name: 'forgetPassword',
			component: forgetPassword
		},
		{
			path: '*',
			name: 'gene',
			component: Gene,
			beforeEnter: requireAuth,
			meta: {permissions: 'active',condition: 'any'}
		}
	]
});

function requireAuth (to, from, next){
	store.dispatch('getCredentials').then(test => {
		if (!test) {
			next({
				path: '/login',
				query: {redirect: to.fullPath}
			})
		} else {
			if (to.matched.some(record => record.meta.permissions.length > 0)) {
				store.dispatch('checkPermissions',{permissions: to.meta.permissions, condition: to.meta.condition}).then(res => {
					if (res) {
						next();
					} else {
						next({
							path: '/permissionDenied'
						});
					}					
				})
			} else {
				next();
			}

		}
	});
}
export default router;